import type { PersonRef } from '../domain/people';

type Named = Pick<PersonRef, 'firstName' | 'lastName'>;

/** A person's full name, as everyone else sees it. */
export function fullName(person: Named): string {
  return `${person.firstName} ${person.lastName}`.trim();
}

/** Up to two initials, for anyone without a photo (decision #5). */
export function initials(person: Named): string {
  return `${person.firstName.charAt(0)}${person.lastName.charAt(0)}`.toUpperCase();
}

/** Whether this is the signed-in person. */
export function isMe(
  person: Pick<PersonRef, 'id'> | null | undefined,
  myId: string | null,
): boolean {
  return !!myId && !!person && person.id === myId;
}
